export enum EClientStatus {
  PENDING = "pending",
  ACTIVE = "active",
  REJECTED = "rejected",
  EXPIRED = "expired",
}

export enum ETeamSize {
  UpTo20 = "up_to_20",
  From20To60 = "20_to_60",
  From60To100 = "60_to_100",
  Over100 = "over_100",
}
